import styled from 'styled-components';
import { Absolute } from '../box/Absolute';

export const PlusMinusIconWrapper = styled(Absolute)`
  right: 7px;
  cursor: pointer;
  top: 7px;
  z-index: 10;
`;
